import type { FC, ReactNode } from "react";

import type { IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import type { QuotaTagCreditsVisualState } from "app/pages/sales-intelligence/modules/quota/types";

import type { QuotaTagSize, QuotaTagType } from "./QuotaTag.types";
import { StyledQuotaTag, StyledQuotaTagTitle, StyledSWReactIcons } from "./styles";

interface QuotaTagProps {
    iconName?: IconName;
    size: QuotaTagSize;
    type: QuotaTagType;
    title: string | number;
    extendedCredits?: boolean;
    creditsVisualState?: QuotaTagCreditsVisualState;
    creditsDepleted?: boolean;
    tooltipContent?: ReactNode;
    dataAutomation?: string;
}

const QuotaTag: FC<QuotaTagProps> = ({
    iconName = "spend",
    title,
    type = "light",
    size = "sm",
    extendedCredits = false,
    creditsVisualState = "default",
    creditsDepleted = false,
    tooltipContent,
    dataAutomation = "quota-tag",
}) => {
    const tag = (
        <StyledQuotaTag
            type={type}
            size={size}
            $extendedCredits={extendedCredits}
            $creditsVisualState={creditsVisualState}
            $creditsDepleted={creditsDepleted}
            data-automation={dataAutomation}
        >
            <StyledSWReactIcons
                iconName={iconName}
                size="16px"
                iconColor={colorsPalettes.midnight[400]}
            />
            <StyledQuotaTagTitle size={size}>{title}</StyledQuotaTagTitle>
        </StyledQuotaTag>
    );

    if (extendedCredits && tooltipContent) {
        return (
            <Tooltip
                placement="top"
                content={tooltipContent}
            >
                {tag}
            </Tooltip>
        );
    }

    return tag;
};

export default QuotaTag;
